import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
    field: {
        margin: 5
    },
    readonlyField: {
        margin: 20
    },
    wrapper: {
        borderRadius: '5px',
        marginTop: 20,
        minHeight: 85,
        display: 'flex'
    },
    title: {
        borderRadius: '5px', 
        padding:"20px"
    },
    legTitle: {
        fontWeight: 'bold',
        paddingLeft: '1rem',
        fontSize: 14
    },
    formWrapper: {
        borderRadius: '5px',
        marginTop: 20,
        minHeight: 85,
        display: 'flex',
        border: "solid 1px lightgrey"
    },
    actionButtons: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.5rem',
        fontSize: 12,
        cursor: 'pointer',
        transition: 'transform 0.1s ease, box-shadow 0.1s ease',
        '&:hover': {
            boxShadow: theme.shadows[2],
            transform: 'scale(1.03)',
        },
        '&:active': {
            transform: 'scale(0.95)',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
        },
    },
    actionButtonWrapper: {
        textAlign: "center",
        marginLeft: 100,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex'
    }
}))